import FanLevelCard from "../components/FanLevelCard";
import ReferralCard from "../components/ReferralCard";
import BestTimeToDrop from "../components/BestTimeToDrop";
import VerificationCard from "../components/VerificationCard";
import PushSubscribeButton from "../components/PushSubscribeButton";
import NotifyFansCard from "../components/NotifyFansCard";
import { useAuth } from "../App";

const GrowthHub = ({ token }) => {
  const { isArtist, user } = useAuth();
  return (
    <div className="space-y-6" data-testid="growth-hub">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="font-['Unbounded'] text-3xl font-bold text-white mb-2">Growth Hub</h1>
          <p className="text-[#8A92A0]">Level up your status. Invite your community. Earn XP, badges, and grow on autopilot.</p>
        </div>
        <PushSubscribeButton token={token} />
      </div>

      {/* Verification (artists only — silently hides for supporters) */}
      <VerificationCard token={token} />

      {(isArtist || user?.is_admin) && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <FanLevelCard token={token} />
          <ReferralCard token={token} />
        </div>
      )}

      {/* Notify Fans (artists only) + Best Time To Drop (artists only) */}
      <NotifyFansCard token={token} />
      <BestTimeToDrop token={token} />

      {/* How XP Works */}
      <div className="card p-6">
        <h2 className="font-['Unbounded'] text-lg font-semibold text-white mb-4">How XP Works</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
          {[
            { label: "Purchase", xp: "+25 XP" },
            { label: "Refer a friend", xp: "+50 XP" },
            { label: "Community post", xp: "+10 XP" },
            { label: "Follow an artist", xp: "+5 XP" },
            { label: "Daily login streak", xp: "+3 XP/day" },
            { label: "Like a post", xp: "+2 XP" }
          ].map((a) => (
            <div key={a.label} className="flex items-center justify-between bg-[#050810] rounded-lg p-3 border border-[#1A2030]">
              <span className="text-[#8A92A0]">{a.label}</span>
              <span className="text-[#EC008C] font-semibold">{a.xp}</span>
            </div>
          ))}
        </div>

        <div className="mt-5 pt-5 border-t border-[#1A2030]">
          <p className="text-xs text-[#8A92A0] uppercase tracking-wide mb-3">Level Thresholds</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[
              { name: "Bronze", xp: "0", color: "#CD7F32" },
              { name: "Silver", xp: "100", color: "#C0C0C0" },
              { name: "Gold", xp: "500", color: "#32D583" },
              { name: "Diamond", xp: "2,000", color: "#B9F2FF" }
            ].map((l) => (
              <div key={l.name} className="bg-[#050810] rounded-lg p-3 border text-center" style={{ borderColor: `${l.color}40` }}>
                <p className="text-sm font-bold" style={{ color: l.color }}>{l.name}</p>
                <p className="text-xs text-[#8A92A0]">{l.xp} XP</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrowthHub;
